 <template>
 <div>

  <v-autocomplete
    style="margin: 0px; padding-top: 10px; width: 100%; float: left"
    no-filter
    v-model="choosed"
    return-object
    clearable
    :search-input.sync="searchString"
    :items="points"
    color="primary"
    hide-no-data
    item-text="name"
    item-value="id"
    :label="label"
    :loading="loading"
    :prepend-icon="!hideIcon ? 'mdi-database-search' : ''"
    :append-outer-icon="!hideOuterIcon && $can('upsert', config.entityName) ? 'mdi-pencil' : ''"
    @input="selected"
    @click:clear="clear"
    :disabled="disabled"
    :readonly="readonly"
    :rules="rules"
    @click:append-outer="openUpsert = true"
    :data-test="dataTest"
  >

    <template slot="item" slot-scope="{ item }">
      <v-list-item-content>
        <v-list-item-title>{{ item.name }} </v-list-item-title>
        <v-list-item-subtitle>{{ item.address }} - {{ item.cap }} - {{ item.city }} ({{ item.prov }})</v-list-item-subtitle>
        <v-list-item-subtitle>{{item.info}}</v-list-item-subtitle>
        <v-list-item-subtitle>{{toAttentionOf(item)}} </v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>

  <v-dialog
      v-if="$can('upsert', config.entityName)"
      v-model="openUpsert"
      :max-width="'700px'">
      <slot name="upsert">
        <core-upsert
          v-if="openUpsert"
          title="Edit Point"
          :item="choosed"
          :config="config"
          :readonly="!$can('upsert', config.entityName)"
          modal
          @saved="upsertSaved"
          @close="openUpsert=false" />
        </slot>
  </v-dialog>

 </div>
</template>
 
 <script>
let { getList, getDetail } = require("@/api/base_entity");
import config from '../../views/point/config_index.js'

export default {
  props: {
    value: {type: Number, default: null},
    disabled: {type: Boolean, default: false},
    readonly: {type: Boolean, default: false},
    label: {type: String, default: ''},
    rowsPerPage: {type: Number, default: 30},
    sesso: {type: String, default: null},
    rules: {type: Array, default() { return [] }},
    filters: {type: Function, default: function(val) { return {name:  "%" + val + "%"} }},
    hideIcon: {type: Boolean, default: false},
    hideOuterIcon: {type: Boolean, default: false},
    firstLoad: {type: Boolean, default: true},
    dataTest: {type: String, default: null},
  },
  data() {
    return {
      config,
      openUpsert: false,
      searchString: null,
      choosed: {},
      loading: false,
      points: [],
      firstLoadLocal:true
    }
  },
  mounted() {
    //commentato perchè adesso 
    // if(this.firstLoad && this.isNew) {
    //   this.search('')
    // }
  },
  watch: {
     value: {
    handler(id) {
      if(id) {
        getDetail('point', id).then(ret =>  {
          // ret.codice_nome = ret.codice + ' - ' + ret.nome
          this.points = [ret];
          this.choosed = ret;
        });
      } else {
        this.points = [];
        this.choosed = null;
      }
    },
    immediate: true
  },
    
    searchString(val) {
      this.search(val)
    },
  },
  computed: {
    isNew() {
      return !this.value
    }
  },
  methods: {
    search(val) {
      if(!this.isNew && this.firstLoadLocal) {
        this.firstLoadLocal = false
        return;
      }
      this.loading = true;
      const filters = typeof this.filters == 'function' ? this.filters(val) : {name:  "%" + val + "%"}
      filters['enabled'] = 1
      getList('point', filters, { rowsPerPage: this.rowsPerPage, sortBy: 'name' }).then(data => {
        data.data.forEach( el => { el.codice_nome = el.codice + ' - ' + el.nome })
        this.points = data.data;
        this.loading = false;
      });
    },
    removeExcludedVal(){
          this.points=this.points.filter((item)=>item.id != this.excludedVal)
    },
    selected() {
      const choosed =  this.choosed ?  this.choosed.id : null
      this.$emit("input", choosed);
      this.$emit("inputObj",  this.choosed);       
    },
    clear() {
      this.$emit("input", null);
      this.$emit("inputObj", null);     
    },
    editPoint() {
      // console.log("edit point")
    },
    upsertSaved() {

    },
    toAttentionOf(item) {

      if(item.site_id) {
        return item.siteToAttentionOf && item.siteToAttentionOf.map( el => el.name + ' ' + el.surname).join(' | ')
      }

      if(item.lab_id) {
        return item.labToAttentionOf && item.labToAttentionOf.map( el => el.name + ' ' + el.surname).join(' | ')
      }

    }
  }
};
</script>
 
 <style>
</style>